import { Language } from '../../types/user/User'
import { CHANGE_LANGUAGE } from './types'

export const changeLanguageAction = (language: Language) => ({
  type: CHANGE_LANGUAGE,
  payload: language
})
